import { useState, useRef, useEffect, useMemo } from 'react';
import { convertDateToUtc, getRemainingTime } from './utils/utils';
import useCountDown from './hooks/use-countdown';

export const WithCutoffTime = (cutoffTime?: string, timezone?: string) => {
  const cutoffTimeGMT = useMemo(
    () => ({
      cutoffTime: cutoffTime ?? null,
      timezone: timezone ?? null
    }),
    [cutoffTime, timezone]
  );

  const pickupDeliverPrevTime = useRef({ hours: null, minutes: null });

  const [remainingTime, setRemainingTime] = useState({
    total: 0,
    hours: null,
    minutes: null,
    isReachedCutOff: false
  });

  const updateRemainingTime = (setRemainingTime, date, timezone) => {
    if (!date) {
      setRemainingTime({
        total: 0,
        hours: null,
        minutes: null,
        isReachedCutOff: false
      });
      return;
    }
    const dateUtc = convertDateToUtc(date, timezone);
    const { total, hours, minutes } = getRemainingTime(dateUtc);
    setRemainingTime((prev) => ({
      ...prev,
      total,
      hours,
      minutes
    }));
  };

  useEffect(() => {
    const { cutoffTime = new Date(), timezone = '' } = cutoffTimeGMT || {};
    updateRemainingTime(setRemainingTime, cutoffTime, timezone);
  }, [cutoffTimeGMT]);

  const updateCalculateTime = ({ setTime, hours, minutes }) =>
    setTime((prev) => {
      return {
        ...prev,
        ...(prev.hours !== hours && {
          hours: hours
        }),
        ...(hours + minutes <= 0 && {
          isReachedCutOff: true
        }),
        ...(prev.minutes !== minutes && {
          minutes: minutes
        })
      };
    });

  const isUpdateTimer = (hours, minutes, prevTime, remainingTime) => {
    return (
      Math.abs(hours + minutes) >= 0 &&
      !remainingTime.isReachedCutOff &&
      (prevTime.current.minutes !== minutes || prevTime.current.hours !== hours)
    );
  };

  useCountDown(remainingTime?.total, (hours, minutes) => {
    if (isUpdateTimer(hours, minutes, pickupDeliverPrevTime, remainingTime)) {
      pickupDeliverPrevTime.current.minutes = minutes;
      pickupDeliverPrevTime.current.hours = hours;
      updateCalculateTime({
        setTime: setRemainingTime,
        hours,
        minutes
      });
    }
  });

  return {
    remainingTime
  };
};
